module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/district/district-form/district-form.component.css
// module id = ./src/app/masters/district/district-form/district-form.component.css
// module chunks = main